import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const Signboards = () => {

  const servicesFaqData = [
    {
        question: "What are signboards, and where are they used?",
        answer: "Signboards are visual displays used for advertising, branding, and informational purposes, typically installed indoors or outdoors. They are widely used in retail stores, offices, events, and public spaces to attract attention and convey messages effectively. Signboards enhance visibility and communicate essential details such as promotions, directions, or brand identity. With durable materials and custom designs, they are a vital tool for businesses seeking to create a professional image. From storefront signage to event displays, signboards are critical in effective communication and marketing."
    },
    {
        question: "What are the benefits of custom sign board printing?",
        answer: "Custom sign board printing allows businesses to create signage tailored to their needs, including size, design, and branding. Customized signboards enhance brand recognition by incorporating logos, colours, and messaging that align with your identity. They offer flexibility in material choices, ensuring durability and suitability for various environments. High-quality custom signboards also make a strong visual impact, helping to attract and engage potential customers. Customised signboards provide a professional and cohesive appearance that supports your marketing efforts, whether for indoor or outdoor use."
    },
    {
        question: "Can Printingy handle bulk orders for signboard printing?",
        answer: "Printingy specializes in bulk sign board printing, offering cost-effective solutions for businesses, events, and campaigns. Our bulk printing services ensure consistent quality across all orders, regardless of size or complexity. By leveraging advanced technology, we provide competitive pricing without compromising visual or material standards. Bulk signboards are ideal for companies with multiple locations, large-scale promotions, or events requiring extensive signage. Printingy’s streamlined processes ensure timely delivery, making us a trusted partner for bulk printing needs."
    },
    {
        question: "What materials are used for outdoor sign board design printing?",
        answer: "Printingy uses durable materials such as aluminium, acrylic, and PVC for outdoor sign board design printing, all designed to withstand weather conditions. These materials ensure that your signage remains vibrant and intact despite sunlight, rain, and wind exposure. High-quality UV-resistant inks are also used to prevent fading, ensuring long-lasting visibility. We also offer finishing options like lamination or protective coatings to enhance durability and maintain the signboard’s aesthetic appeal. These materials provide your outdoor signboards are functional and visually striking, making them perfect for long-term use."
    },
    {
        question: "What industries benefit from signboard printing services?",
        answer: "Industries such as retail, hospitality, real estate, education, and events greatly benefit from signboard printing services. Retailers use signboards to advertise sales and highlight product information. Hospitality businesses rely on signboards for wayfinding and promotional messaging. Real estate companies use durable outdoor signs to promote properties and listings. Educational institutions and event organizers use them to provide directions and display schedules. The versatility and effectiveness of signboards make them indispensable tools for communication across various sectors."
    }
  ];


const [pageTitle, setPageTitle] = useState('Printing of Signboards');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom Signboard Printing Services for Businesses"
  description="High-quality printing of signboards for indoor and outdoor use. Bulk custom sign board printing, outdoor design printing, and signage solutions."
  keywords="Printing of Signboards,
Sign Board Printing,
Sign Board Printing Services,
Customize Sign Board Printing,
Outdoor Sign Board Design Printing"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Signboards</h1>
              <h2 className="text-muted">
              Custom signboards for impactful indoor and outdoor displays 
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Signboards are essential for businesses, offering high visibility and effective communication for branding, promotions, and information display. Printingy specializes in the Printing of Signboards, providing high-quality and customised sign board printing for diverse needs.</p>
          <p>Our services include sign board printing services with tailored designs that reflect your branding. For outdoor displays, we deliver durable and weather-resistant outdoor sign board design printing solutions. Whether for storefronts, events, or advertising campaigns, our signboards ensure professional and impactful results.</p>
          <p>With bulk printing capabilities and advanced technology, Printingy ensures cost-effective, high-quality signboard solutions to meet your requirements.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Signboard Printing Solutions</h2>
                <h3 className="large-hed">High-quality, durable, and versatile signboards for all purposes</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Signboards for indoor and outdoor applications.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk sign board printing at competitive rates for large-scale orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully customize sign board printing tailored to your branding.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable outdoor sign board design printing for long-term visibility.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced technology ensures sharp graphics and fade-resistant visuals.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Lightweight and portable options for easy installation and use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customized orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for businesses, event organizers, and corporate branding.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/signboards.jpg" // Path relative to the public folder
                  alt="Professional printing of signboards services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Signboards Delivered On Time</h2>
            <h3 className="small-hed">Focus on your branding while we manage your signboard printing needs </h3>
            <p>At Printingy, we combine advanced printing techniques with premium materials to deliver exceptional customize sign-board printing solutions. Whether you need indoor signage for branding or weather-resistant outdoor displays, our sign board printing services ensure sharp visuals and durable results.</p>
            <p>We prioritize quality and timely delivery for all bulk orders, ensuring your signage is ready when needed. Partner with Printingy for reliable, professional signboard solutions that enhance branding and communication.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default Signboards;
